import React from 'react';
import PropTypes from 'prop-types';
import { Steps } from 'antd';
import './index.css';

const { Step } = Steps;

const ProgressStepsContainer = ({ current, skipASA, isProgrammerRole }) => {
  if (skipASA) {
    return (
      <div className="new-mcq-step-wrapper-for-no-programmer">
        <Steps current={current} labelPlacement="vertical" className="new-mcq-progress-step-for-no-programmer">
          <Step className="new-mcq-left-align" title={<div><span>Welcome</span><br /><span>to Turing</span></div>} />
          <Step className="progress-title-center-3-steps" title={<div><span>Pass your</span><br /><span>1st test</span></div>} />
          <Step className="progress-title-right-3-steps" title={<div><span>Pass a tech stack</span></div>} />
        </Steps>
      </div>
    );
  }
  return (
    <div className="new-mcq-step-wrapper">
      <Steps current={current} labelPlacement="vertical" className="new-mcq-progress-step">
        <Step className="new-mcq-left-align" title={<div><span>Welcome</span><br /><span>to Turing</span></div>} />
        <Step className="new-mcq-left-center-align" title={<div><span>Take the work</span><br /><span>experience survey</span></div>} />
        <Step className="new-mcq-last-tail" title={<div><span>Pass your</span><br /><span>1st test</span></div>} />
        <Step className="new-mcq-right-align" title={
          isProgrammerRole ? (
            <div>
              <span className="new-mcq-progress-step-text last-step">Pass a tech stack to unlock</span><br/>
              <span className="new-mcq-progress-step-text last-step">the coding challenge</span>
            </div>
          ) : (
            <div><span className="new-mcq-progress-step-text last-step">Pass a tech stack</span></div>
          )
        } />
      </Steps>
    </div>
  );
};

ProgressStepsContainer.propTypes = {
  isProgrammerRole: PropTypes.bool,
  current: PropTypes.number,
  passRequire: PropTypes.number,
  allRequire: PropTypes.bool,
  skipASA: PropTypes.bool
};

export default ProgressStepsContainer;
